// extracted by mini-css-extract-plugin
export default {"viewTab":"ViewTab_viewTab__Rj+KF","viewTab__wrapper":"ViewTab_viewTab__wrapper__NvjOR","viewTab__icon":"ViewTab_viewTab__icon__FPL6z"};